import React from "react";
import "../../../modal.css";

export default function CloseConfirmationDialog({ confirmationAction }) {
    return (
        <div id="popup2" class="overlay open">
            <div class="chatpopup">
                <div class="feedbackdone">
                    <>
                        <div className="heading textleft">Do you want to close the chat?</div>
                        <div class="chatclose-option">

                            <div className="chatBtn" onClick={() => confirmationAction(true)}>Yes</div>
                            <div className="chatBtn" onClick={() => confirmationAction(false)} >No</div>
                        </div>
                    </>
                </div>
            </div>
        </div>
    );
}